import { useEffect, useState } from 'react'
import { com, kotlin } from '@eidu/form'
import getPermittedActions from './api/entity/permission/getPermittedActions'
import PermittedActions = com.eidu.sharedlib.entity.permission.PermittedActions
import KtList = kotlin.collections.KtList
import PermittedAction = com.eidu.sharedlib.entity.permission.PermittedAction

const usePermittedActions = (
  requested: readonly PermittedAction[],
  deps?: readonly unknown[]
): [readonly PermittedAction[] | undefined, string | undefined, boolean] => {
  const [permissions, setPermissions] = useState<readonly PermittedAction[]>()
  const [error, setError] = useState<string | undefined>(undefined)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const fetchPermissions = async () => {
      setLoading(true)
      const userPermissions = await getPermittedActions({
        requested: new PermittedActions(KtList.fromJsArray(requested)),
      })
      setPermissions(userPermissions.permittedActions.asJsReadonlyArrayView())
    }
    fetchPermissions()
      .catch((err) => {
        setError(err instanceof Error ? err.toString() : String(err))
      })
      .finally(() => {
        setLoading(false)
      })
  }, [requested, ...(deps ?? [])])

  return [permissions, error, loading]
}

export default usePermittedActions
